import { HbPoItemDetails } from "./hb-po-item-details";

export class HbPoDetails {
    custPo: string;
    exitFactoryDate: string;
    shipToAdd: string;
    currency:string;
 
    HbpoItemDetails: HbPoItemDetails[]
}